import { render, staticRenderFns } from "./ColumnSorting.vue?vue&type=template&id=3e9e1ca3&scoped=true&lang=pug"
import script from "./ColumnSorting.vue?vue&type=script&lang=js"
export * from "./ColumnSorting.vue?vue&type=script&lang=js"
import style0 from "./ColumnSorting.vue?vue&type=style&index=0&id=3e9e1ca3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9e1ca3",
  null
  
)

export default component.exports